import AdSlot from "@/components/AdSlot";
import { useAdSetting } from "@/lib/adSettings";

/**
 * Desktop-only sticky ads in the left & right margins. Hidden below 1400px (where
 * there isn't enough margin beside the centered content) and on tablet/mobile.
 * Each rail is independently controlled from Admin → Ads.
 */
export default function AdSideRail() {
    const rightOn = useAdSetting("side_rail");
    const leftOn = useAdSetting("side_rail_left");
    const rightSlot = process.env.REACT_APP_ADSENSE_SIDE_RAIL_SLOT;
    const leftSlot = process.env.REACT_APP_ADSENSE_SIDE_RAIL_LEFT_SLOT;
    return (
        <>
            {leftOn && (
                <div className="hidden min-[1400px]:block fixed left-6 top-24 z-30" style={{ width: 160 }} data-testid="ad-side-rail-left">
                    <AdSlot slot={leftSlot} format="vertical" responsive={false} minHeight={600} refreshKey="side-rail-left" placement="side_rail_left" />
                </div>
            )}
            {rightOn && (
                <div className="hidden min-[1400px]:block fixed right-6 top-24 z-30" style={{ width: 160 }} data-testid="ad-side-rail">
                    <AdSlot slot={rightSlot} format="vertical" responsive={false} minHeight={600} refreshKey="side-rail" placement="side_rail" />
                </div>
            )}
        </>
    );
}
